export const clientWidthType = Object.freeze({
  WIDE: 1500,
  COMMON: 1300,
  TIGHT: 700
})
export const emptyShortDescription = 'Описание отсутствует'

export const subjectsOfRussia = Object.freeze({
  'RU-PNZ': 'Пензенская область',
  'RU-VLA': 'Владимирская область',
  'RU-LEN': 'Ленинградская область',
  'RU-SAK': 'Сахалинская область',
  'RU-KYA': 'Красноярский край',
  'RU-UD': 'Удмуртская республика',
  'RU-IVA': 'Ивановская область',
  'RU-LIP': 'Липецкая область',
  'RU-AST': 'Астраханская область',
  'RU-CE': 'Чеченская республика',
  'RU-KHA': 'Хабаровский край',
  'RU-ORE': 'Оренбургская область',
  'RU-KIR': 'Кировская область',
  'RU-BA': 'Республика Башкортостан',
  'RU-NGR': 'Новгородская область',
  'RU-KLU': 'Калужская область',
  'RU-OMS': 'Омская область',
  'RU-SAR': 'Саратовская область',
  'RU-ORL': 'Орловская область',
  'RU-STA': 'Ставропольский край',
  'RU-SE': 'Республика Северная Осетия-Алания',
  'RU-SAM': 'Самарская область',
  'RU-SA': 'Республика Саха',
  'RU-SVE': 'Свердловская область',
  'RU-KK': 'Республика Хакасия',
  'RU-MOS': 'Московская область',
  'RU-BEL': 'Белгородская область',
  'RU-KHM': 'Ханты-Мансийский АО',
  'RU-VLG': 'Вологодская область',
  'RU-CHE': 'Челябинская область',
  'RU-YAR': 'Ярославская область',
  'RU-TUL': 'Тульская область',
  'RU-IRK': 'Иркутская область',
  'RU-NIZ': 'Нижегородская область',
  'RU-YAN': 'Ямало-Ненецкий АО',
  'RU-KGD': 'Калининградская область',
  'RU-KAM': 'Камчатский край',
  'RU-BU': 'Республика Бурятия',
  'RU-KEM': 'Кемеровская область',
  'RU-CHU': 'Чукотский АО',
  'RU-ULY': 'Ульяновская область',
  'RU-KGN': 'Курганская область',
  'RU-KRS': 'Курская область',
  'RU-KR': 'Республика Карелия',
  'RU-ME': 'Республика Марий Эл',
  'RU-IN': 'Республика Ингушетия',
  'RU-MAG': 'Магаданская область',
  'RU-MO': 'Республика Мордовия',
  'RU-TA': 'Республика Татарстан',
  'RU-ZAB': 'Забайкальский край',
  'RU-RYA': 'Рязанская область',
  'RU-TAM': 'Тамбовская область',
  'RU-ARK': 'Архангельская область',
  'RU-KC': 'Карачаево-Черкесская Республика',
  'RU-TY': 'Республика Тыва',
  'RU-MUR': 'Мурманская область',
  'RU-VOR': 'Воронежская область',
  'RU-PSK': 'Псковская область',
  'RU-TVE': 'Тверская область',
  'RU-VGG': 'Волгоградская область',
  'RU-KOS': 'Костромская область',
  'RU-KL': 'Республика Калмыкия',
  'RU-TOM': 'Томская область',
  'RU-KO': 'Республика Коми',
  'RU-TYU': 'Тюменская область',
  'RU-DA': 'Республика Дагестан',
  'RU-NVS': 'Новосибирская область',
  'RU-AD': 'Республика Адыгея',
  'RU-PER': 'Пермский край',
  'RU-ROS': 'Ростовская область',
  'RU-PRI': 'Приморский край',
  'RU-KB': 'Кабардино-Балкарская республика',
  'RU-AL': 'Республика Алтай',
  'RU-NEN': 'Ненецкий АО',
  'RU-ALT': 'Алтайский край',
  'RU-KDA': 'Краснодарский край',
  'RU-YEV': 'Еврейская АО',
  'RU-AMU': 'Амурская область',
  'RU-BRY': 'Брянская область',
  'RU-SMO': 'Смоленская область',
  'RU-CU': 'Чувашская республика',
  'RU-KRM': 'Республика Крым',
  'RU-DNR': 'Донецкая Народная Республика',
  'RU-LNR': 'Луганская Народная Республика',
  'RU-ZPR': 'Запорожская область',
  'RU-HRS': 'Херсонская область',
  'RU-SPB': 'Санкт-Петербург',
  'RU-MSK': 'Москва',
  'RU-SEV': 'Севастополь'
})
